module.exports = __webpack_public_path__ + "img/solar-panel.b29aeec0.png";